import { combineReducers } from "redux";
import { ReportModel } from "./types";
import {
  ReportRiskProfileCommand,
  ReportRiskProfileDefault,
  ReportRiskProfileReducer,
} from "./risk-profile/reducers";
import {
  GetAllReportDefault,
  ReportAllCommand,
  ReportAllReducer,
} from "./report-rcsa/reducer";

const ReportReducer = combineReducers({
  riskProfile: ReportRiskProfileReducer,
  getAllReport: ReportAllReducer,
});

const ReportDefault: ReportModel = {
  riskProfile: ReportRiskProfileDefault,
  getAllReport: GetAllReportDefault,
};

const ReportCommand = {
  riskProfile: ReportRiskProfileCommand,
  getAllReport: ReportAllCommand,
};

export { ReportReducer, ReportDefault, ReportCommand };
